import type { PortalStrings } from "./en";

export const fr: PortalStrings = {
  shell: {
    portal: "Portail client",
    nav: {
      home: "Accueil",
      case: "Mon dossier",
      caseShort: "Dossier",
      tasks: "Tâches",
      documents: "Documents",
      profile: "Mon profil",
      profileShort: "Profil"
    },
    signOut: "Se déconnecter",
    language: "Langue",
    previewing:
      "Vous voyez le portail de {{name}} tel qu'il le voit. Lecture seule : rien n'est enregistré ni envoyé ici.",
    exitPreview: "Quitter l'aperçu",
    privacy:
      "Seuls vous et votre équipe juridique pouvez voir vos informations.",
    notClient: "Ce compte n'a pas de portail client",
    notClientBody:
      "Demandez à votre équipe juridique de vous inviter, ou connectez-vous avec l'adresse e-mail qui a reçu l'invitation.",
    useDifferentEmail: "Utiliser une autre adresse e-mail",
    cantPreview: "Impossible d'afficher l'aperçu de ce portail",
    loadFailed:
      "Nous n'avons pas pu charger votre portail. Réessayez dans un instant.",
    retry: "Réessayer"
  },
  greeting: {
    morning: "Bonjour {{name}}",
    afternoon: "Bon après-midi {{name}}",
    evening: "Bonsoir {{name}}",
    withTasks_one: "Voici la seule chose dont nous avons besoin.",
    withTasks_other: "Voici ce dont nous avons besoin de votre part.",
    stageLine: {
      started: "Votre dossier démarre.",
      gathering: "Nous rassemblons les informations pour votre dossier.",
      review: "Votre avocat examine votre dossier.",
      filed: "Votre dossier a été déposé auprès de l'USCIS.",
      decision: "Votre dossier en est à l'étape de la décision."
    },
    allCaughtUp:
      "Tout est à jour. Nous vous préviendrons si nous avons besoin de quelque chose."
  },
  tasks: {
    title: "Ce dont nous avons besoin",
    count_one: "1 tâche",
    count_other: "{{count}} tâches",
    none: "Rien pour l'instant",
    noneBody:
      "Quand votre équipe juridique aura besoin de quelque chose, cela apparaîtra ici.",
    progress: "{{answered}} sur {{total}} répondues",
    minutesLeft_one: "environ 1 minute restante",
    minutesLeft_other: "environ {{count}} minutes restantes",
    due: "à rendre le {{date}}",
    dueToday: "à rendre aujourd'hui",
    overdue: "était à rendre le {{date}}",
    changesRequested:
      "Votre équipe juridique vous demande de mettre à jour quelques réponses",
    start: "Commencer",
    continue: "Continuer",
    update: "Mettre à jour les réponses",
    opening: "Ouverture…",
    openFailed:
      "Nous n'avons pas pu ouvrir cette tâche. Utilisez le lien de votre e-mail ou réessayez.",
    previewOnly: "Les tâches ne s'ouvrent que pour le client.",
    sign: "Relire et signer",
    ink: "Commencer",
    notYet: "Pas encore",
    signMeta: "Environ {{minutes}} minutes",
    inkMeta:
      "Imprimer, signer à l'encre, envoyer une photo · environ {{minutes}} minutes",
    upcoming: "S'ouvre quand le document est prêt pour votre signature",
    sendAgain: "Votre équipe juridique vous demande de l'envoyer à nouveau"
  },
  case: {
    title: "Votre dossier",
    titlePlural: "Vos dossiers",
    fullTimeline: "Chronologie complète",
    now: "Où en est-on",
    onHold:
      "Votre dossier est en pause pour le moment. Votre équipe juridique vous dira quand il reprend.",
    approved: "Approuvé",
    decision: "Décision rendue",
    receipts: "Reçus de l'USCIS",
    noReceipts:
      "Votre numéro de reçu apparaîtra ici dès que l'USCIS l'aura envoyé.",
    checkStatus: "Vérifier le statut à l'USCIS",
    checking: "Vérification…",
    checkedAt: "Vérifié {{when}}",
    statusFailed: "L'USCIS ne répond pas pour le moment. Réessayez plus tard.",
    details: "Détails du dossier",
    caseType: "Type de dossier",
    opened: "Ouvert le",
    priorityDate: "Date de priorité",
    updates: "Actualités",
    noUpdates: "Les actualités de votre dossier apparaîtront ici.",
    none: "Aucun dossier pour l'instant",
    noneBody:
      "Quand votre équipe juridique ouvrira votre dossier, vous pourrez le suivre ici.",
    back: "Tous les dossiers",
    notFound: "Nous n'avons pas trouvé ce dossier.",
    step: "Étape {{n}} sur {{total}}",
    startedOn: "commencé le {{date}}",
    nowChip: "En cours",
    waitingOnYou: "En attente de votre part",
    open: "Ouvrir",
    attorney: "Avocat",
    receiptNumber: "Numéro de reçu",
    receiptLater: "Affiché ici après le dépôt",
    priorityLater: "Fixée à la réception par l'USCIS",
    questions: "Des questions sur votre dossier ?",
    emailLead: "Écrire à {{name}}"
  },
  milestone: {
    rfe: "L'USCIS a demandé des preuves supplémentaires (une demande de preuves, RFE). {{lead}} prépare la réponse et vous dira si vous devez fournir quelque chose.",
    interview:
      "L'USCIS a fixé un entretien. {{lead}} vous aidera à vous préparer et vous dira quoi apporter.",
    biometrics:
      "L'USCIS en est à l'étape biométrique : empreintes digitales et photo dans un bureau de l'USCIS. Apportez votre convocation et une pièce d'identité avec photo."
  },
  stageAbout: {
    started:
      "Votre équipe juridique ouvre votre dossier et détermine ce dont elle a besoin de votre part.",
    gathering:
      "Nous rassemblons vos réponses et vos documents : qui vous êtes, votre parcours et les preuves dont votre dossier a besoin.",
    review:
      "Votre avocat vérifie tout, prépare vos formulaires et vos lettres, et peut vous poser quelques questions complémentaires.",
    filed:
      "Nous déposons votre dossier auprès de l'USCIS. Le numéro de reçu apparaîtra ici dès que l'USCIS l'aura envoyé, et vous pourrez suivre son statut depuis cette page.",
    decision:
      "L'USCIS approuve le dossier, demande des preuves supplémentaires (une demande de preuves) ou le refuse. Nous vous expliquerons la suite."
  },
  stage: {
    started: "Mise en route",
    gathering: "Collecte des informations",
    review: "Examen par l'avocat",
    filed: "Déposé auprès de l'USCIS",
    decision: "Décision"
  },
  explainer: {
    yourTeam: "Votre équipe juridique",
    yourTeamLower: "votre équipe juridique",
    started:
      "{{lead}} met en place votre dossier. Tout ce dont nous aurons besoin de votre part apparaîtra sur cette page.",
    gathering:
      "{{lead}} rassemble vos réponses et vos documents. Une fois tout reçu, {{leadFirst}} vérifie l'ensemble et commence à préparer votre demande.",
    review:
      "{{lead}} examine vos informations et prépare votre demande. Vous recevrez peut-être quelques questions complémentaires.",
    filed:
      "Votre dossier a été déposé auprès de l'USCIS. L'USCIS envoie généralement d'abord un avis de réception par courrier, puis peut fixer un rendez-vous biométrique. Les délais varient selon le type de dossier.",
    decision:
      "L'USCIS a rendu une décision sur votre dossier. {{lead}} vous expliquera ce qu'elle signifie et les prochaines étapes."
  },
  updates: {
    opened: "Votre dossier a été ouvert",
    filed: "Votre dossier a été déposé auprès de l'USCIS",
    approved: "L'USCIS a approuvé votre dossier",
    decided: "L'USCIS a rendu une décision sur votre dossier",
    reopened: "Votre dossier a été rouvert",
    receipt: "Reçu de l'USCIS {{receipt}} ajouté",
    receipt_unnamed: "Un reçu de l'USCIS a été ajouté",
    questions_sent: "Nous vous avons envoyé des questions",
    answers_received: "Nous avons reçu vos réponses",
    changes_requested:
      "Nous vous avons demandé de mettre à jour quelques réponses",
    answers_reviewed: "Vos réponses ont été examinées"
  },
  comingUp: {
    title: "À venir",
    taskDue: "À rendre : {{title}}",
    allDay: "Toute la journée"
  },
  team: {
    title: "Votre équipe juridique",
    email: "Écrire à {{name}}"
  },
  reminders: {
    title: "À garder en tête",
    expiresIn_one: "{{subject}} expire demain",
    expiresIn_other: "{{subject}} expire dans {{count}} jours",
    expiresToday: "{{subject}} expire aujourd'hui",
    expired: "La date de fin enregistrée pour {{subject}} était le {{date}}",
    expiresHint:
      "Prévenez votre équipe juridique avant de le renouveler ou de prévoir un voyage.",
    expiredHint:
      "Si vous avez reçu un document plus récent, envoyez-le pour que votre équipe juridique l'ait.",
    yours: {
      status: "votre statut {{status}}",
      immigration_status_expiration: "votre statut d'immigration",
      i94_expiration: "votre I-94",
      passport_expiration: "votre passeport",
      ead_expiration: "votre permis de travail (EAD)",
      advance_parole_expiration:
        "votre autorisation de voyage (advance parole)",
      visa_expiration: "votre visa"
    },
    theirs: {
      immigration_status_expiration: "le statut d'immigration de {{name}}",
      i94_expiration: "l'I-94 de {{name}}",
      passport_expiration: "le passeport de {{name}}",
      ead_expiration: "le permis de travail (EAD) de {{name}}",
      advance_parole_expiration:
        "l'autorisation de voyage (advance parole) de {{name}}",
      visa_expiration: "le visa de {{name}}"
    }
  },
  documents: {
    title: "Documents",
    subtitle:
      "Ce que vous nous avez envoyé et ce que votre équipe juridique a partagé avec vous.",
    upload: "Envoyer un document",
    takePhoto: "Prendre une photo",
    uploading: "Envoi de {{name}}…",
    uploaded: "{{name}} envoyé à votre équipe juridique",
    uploadFailed: "{{name}} n'a pas pu être envoyé. Réessayez.",
    fromYou: "Envoyé par vous",
    fromTeam: "De votre équipe juridique",
    open: "Ouvrir",
    remove: "Supprimer",
    removed: "{{name}} supprimé",
    removeFailed: "Suppression impossible. Réessayez.",
    none: "Aucun document pour l'instant",
    noneBody:
      "Envoyez les documents demandés par votre équipe juridique, ou revenez plus tard pour voir ceux qu'elle partage avec vous.",
    previewOnly: "Les envois sont désactivés dans l'aperçu.",
    checking: "Vérification de {{name}}…",
    looksGood: "{{name}} semble correct",
    weRead: "Voici ce que nous avons lu :",
    mayBeHard: "{{name}} est peut-être difficile à lire",
    replace: "Remplacer",
    keep: "Garder"
  },
  sign: {
    from: "De {{name}}",
    inkWhy:
      "L'USCIS exige une signature manuscrite sur les formulaires papier : cette page ne peut donc pas être signée à l'écran.",
    read: "Lisez le document",
    readHint: "Lisez chaque page avant de signer.",
    add: "Ajoutez votre signature",
    draw: "Dessiner",
    type: "Saisir",
    drawHint: "Signez ici avec le doigt ou la souris",
    clear: "Effacer",
    fullName: "Votre nom complet",
    consent:
      "J'accepte de signer ce document électroniquement, et que ma signature électronique ait la même valeur que ma signature manuscrite.",
    signAndSend: "Signer et envoyer à {{name}}",
    signing: "Signature en cours…",
    audit:
      "Nous vous envoyons une copie signée par e-mail. Votre signature, l'heure et une empreinte du document sont enregistrées pour pouvoir le vérifier plus tard.",
    needSignature: "Dessinez ou saisissez d'abord votre signature.",
    needConsent: "Cochez la case pour accepter la signature électronique.",
    failed: "La signature a échoué. Réessayez.",
    signed: "Signé",
    signedBody:
      "Vous l'avez signé le {{date}}. Nous vous avons envoyé une copie par e-mail.",
    signedNoCopy: "Vous l'avez signé le {{date}}.",
    downloadSigned: "Télécharger votre copie signée",
    print: "Imprimez la page",
    download: "Télécharger la page à signer (PDF)",
    noPrinter:
      "Pas d'imprimante ? Demandez à votre équipe juridique de vous l'envoyer par la poste.",
    inkSign: "Signez à l'encre noire",
    inkBox: "Signez dans la case « {{box}} » de la page {{page}}.",
    inkBoxPage: "Signez dans la case de signature de la page {{page}}.",
    photo: "Prenez une photo de la page signée",
    photoHint:
      "Posez-la à plat, sous une bonne lumière, avec toute la page visible.",
    takePhoto: "Prendre une photo",
    chooseFile: "Choisir un fichier",
    retake: "Reprendre",
    checking: "Vérification de votre photo…",
    found: "Signature trouvée dans la case",
    notFound: "Nous n'avons pas vu de signature dans la case",
    readable: "Page entière visible et lisible",
    notReadable: "Une partie de la page est difficile à lire",
    unchecked:
      "Nous n'avons pas pu vérifier cette photo, mais vous pouvez quand même l'envoyer.",
    send: "Envoyer à {{name}}",
    sendAnyway: "L'envoyer quand même",
    sending: "Envoi en cours…",
    uploadFailed: "La photo n'a pas été envoyée. Réessayez.",
    keepOriginal:
      "Gardez l'original. {{name}} pourrait vous demander de l'envoyer par la poste.",
    sent: "Envoyé à {{name}}",
    sentBody:
      "{{name}} va le vérifier et vous dira s'il faut autre chose. Gardez l'original.",
    completed: "Terminé",
    completedBody: "{{name}} a accepté votre page signée.",
    returned: "{{name}} vous demande de l'envoyer à nouveau :",
    upcoming: "Pas encore prêt",
    upcomingBody:
      "{{name}} vous préviendra quand le document sera prêt pour votre signature.",
    gone: "Ce document n'a plus besoin de votre signature.",
    back: "Retour aux tâches",
    previewOnly: "La signature est désactivée dans l'aperçu.",
    viewer: "Document à signer",
    changed:
      "Ce document a changé après son envoi. Votre équipe juridique vous l'enverra à nouveau."
  },
  profile: {
    subtitle:
      "Ce sont les informations qui figurent sur vos formulaires d'immigration. Si quelque chose est faux ou a changé, proposez une correction et {{name}} l'examinera.",
    about: "Vous",
    contact: "Comment vous joindre",
    lived: "Où vous avez vécu",
    worked: "Où vous avez travaillé",
    studied: "Vos études",
    noneOnFile: "Rien d'enregistré pour l'instant",
    notOnFile: "Non renseigné",
    historyHint: "Il manque quelque chose ou il y a une erreur ?",
    tellUs: "Prévenir {{name}}",
    suggest: "Proposer une correction",
    add: "Ajouter",
    waiting: "En attente de l'examen de {{name}}",
    withdraw: "Retirer",
    withdrawn: "Proposition retirée",
    updated: "Mis à jour",
    kept: "{{name}} a conservé les informations enregistrées.",
    keptWhy: "{{name}} a conservé les informations enregistrées : {{reason}}",
    note: "Quelque chose que {{name}} devrait savoir ?",
    notePlaceholder: "Par exemple : mon passeport a la bonne orthographe.",
    addressPlaceholder: "Si vous avez déménagé, dites-nous quand.",
    historyLabel: "Qu'est-ce qui manque ou qui est faux ?",
    historyPlaceholder:
      "Par exemple : j'ai habité au 12 Elm St, Austin, TX, de juin 2019 à mai 2020.",
    yourNotes: "Vos messages",
    attach: "Joindre un document",
    attachHint: "Une photo ou un PDF qui montre la bonne information.",
    attaching: "Envoi de {{name}}…",
    attachFailed: "Ce fichier n'a pas pu être envoyé. Réessayez.",
    removeAttachment: "Retirer la pièce jointe",
    cancel: "Annuler",
    send: "Envoyer à {{name}}",
    sending: "Envoi…",
    sent: "Envoyé à {{name}} pour examen",
    failed: "Envoi impossible. Réessayez.",
    unchanged:
      "C'est déjà ce que nous avons. Modifiez d'abord une information.",
    previewOnly: "Les propositions sont désactivées dans l'aperçu.",
    present: "aujourd'hui",
    topic: {
      legal_name: "Nom légal",
      other_names: "Autres noms utilisés",
      birthday: "Date de naissance",
      birthplace: "Lieu de naissance",
      citizenships: "Nationalité",
      marital_status: "Situation familiale",
      email: "E-mail",
      phone: "Téléphone",
      physical_address: "Adresse du domicile",
      mailing_address: "Adresse postale",
      history: "Votre parcours"
    },
    field: {
      first_name: "Prénom",
      middle_name: "Deuxième prénom",
      last_name: "Nom de famille",
      other_names: "Autres noms, séparés par des virgules",
      birthday: "Date de naissance",
      city_of_birth: "Ville",
      state_of_birth: "État ou province",
      country_of_birth: "Pays",
      citizenships: "Pays, séparés par des virgules",
      marital_status: "Situation familiale",
      email: "E-mail",
      phone: "Téléphone",
      street: "Rue et numéro",
      city: "Ville",
      state: "État",
      zip_code: "Code postal",
      country: "Pays"
    },
    marital: {
      single: "Célibataire, jamais marié(e)",
      married: "Marié(e)",
      divorced: "Divorcé(e)",
      widowed: "Veuf/veuve",
      separated: "Séparé(e) légalement",
      annulled: "Mariage annulé"
    }
  },
  signIn: {
    title: "Connectez-vous à votre portail",
    sentTitle: "Consultez vos e-mails",
    email: "E-mail",
    send: "M'envoyer un lien de connexion",
    sending: "Envoi…",
    hint: "Aucun mot de passe. Nous enverrons à cette adresse un lien qui vous connecte.",
    sent: "Si {{email}} a un portail client, un lien de connexion est en route. Il ne fonctionne qu'une fois et expire dans une heure.",
    sendAnother: "Utiliser une autre adresse e-mail",
    failed: "Envoi du lien impossible. Réessayez dans une minute.",
    staff: "Vous travaillez dans un cabinet ?",
    staffLink: "Connectez-vous ici"
  },
  welcome: {
    signingIn: "Connexion…",
    expired: "Ce lien a expiré",
    used: "Ce lien a déjà été utilisé",
    invalid: "Ce lien n'est pas valide",
    revoked: "Ce lien ne fonctionne plus",
    off: "L'accès au portail est désactivé",
    offBody: "Demandez à votre équipe juridique de le réactiver.",
    getNew:
      "Saisissez votre adresse e-mail et nous vous enverrons un nouveau lien de connexion."
  },
  intake: {
    language: "Langue",
    showEnglish: "Afficher en anglais",
    showTranslated: "Afficher en {{language}}",
    translating: "Traduction des questions…",
    translationFailed:
      "Nous n'avons pas pu traduire les questions pour le moment ; elles sont en anglais.",
    answerHint:
      "Répondez en anglais si vous le pouvez. Sinon, répondez dans votre langue : votre équipe juridique traduira.",
    defaultNote:
      "Prenez votre temps pour remplir ce questionnaire. Vérifiez que toutes les informations correspondent à vos documents officiels.",
    defaultTitle: "Questionnaire d'immigration",
    start: "Commencer",
    resume: "Reprendre",
    fix_one: "Corriger {{count}} réponse →",
    fix_other: "Corriger {{count}} réponses →",
    takes_one: "Environ {{count}} minute",
    takes_other: "Environ {{count}} minutes",
    left_one: "Environ {{count}} minute restante",
    left_other: "Environ {{count}} minutes restantes",
    about_one: "Environ {{count}} minute",
    about_other: "Environ {{count}} minutes",
    othersSaved_one: " · l'autre réponse est enregistrée",
    othersSaved_other: " · les {{count}} autres réponses sont enregistrées",
    needsChanges_one:
      "Votre avocat a examiné vos réponses et a besoin d'une modification.",
    needsChanges_other:
      "Votre avocat a examiné vos réponses et a besoin de {{count}} modifications.",
    attorney: "Avocat",
    yourAttorney: "Votre avocat",
    yourAttorneyLower: "votre avocat",
    yourFirm: "Votre cabinet",
    you: "Vous",
    welcomeBack: "Bon retour",
    welcomeBackName: "Bon retour, {{name}}.",
    resumeBody:
      "Vous avez déjà commencé ce questionnaire. Voulez-vous reprendre là où vous vous êtes arrêté ?",
    continueWhereLeft: "Reprendre là où je me suis arrêté",
    reviewFromStart: "Revoir depuis le début",
    ok: "OK",
    skip: "Passer",
    continue: "Continuer",
    submit: "Envoyer",
    sendTo: "Envoyer à {{name}}",
    yes: "Oui",
    no: "Non",
    previousStep: "Étape précédente",
    nextStep: "Étape suivante",
    displaySettings: "Options d'affichage",
    typeAnswer: "Saisissez votre réponse ici...",
    yourAnswer: "Votre réponse",
    typeOrSelect: "Saisissez ou choisissez une option",
    noMatches: "Aucune option correspondante",
    street: "Adresse",
    city: "Ville",
    state: "État / Province",
    statePlaceholder: "État",
    postal: "Code postal",
    postalPlaceholder: "Code postal",
    country: "Pays",
    dragDrop: "Glissez-déposez vos fichiers",
    uploadingShort: "Envoi...",
    upload: "Envoyer",
    uploadMore: "Envoyer d'autres fichiers",
    uploadedFiles: "Fichiers envoyés",
    uploadingDocument: "Envoi du document",
    uploaded: "Envoyé",
    uploadedBody_one: "Votre fichier a bien été envoyé.",
    uploadedBody_other: "{{count}} fichiers ont bien été envoyés.",
    someFailed: "Certains fichiers n'ont pas pu être envoyés",
    uploadFailed: "Échec de l'envoi",
    pleaseTryAgain: "Veuillez réessayer.",
    saved: "Enregistré",
    savedBody:
      "Vous pouvez fermer cette page et revenir plus tard avec le même lien.",
    couldntSave: "Enregistrement impossible",
    submitted: "Envoyé",
    submittedBody: "Vos réponses ont bien été envoyées.",
    couldntSubmit: "Envoi impossible",
    thankYou: "Merci !",
    thankYouBody:
      "Votre équipe juridique a reçu vos réponses et les examinera bientôt. Vous pouvez fermer cet onglet.",
    review: "Vérifiez vos réponses",
    reviewBody:
      "Vérifiez vos réponses avant de les envoyer. Vous pouvez modifier ce qui doit l'être.",
    reviewGroupBody:
      "Vous pouvez modifier ou supprimer une entrée, ou en ajouter une autre.",
    edit: "Modifier",
    remove: "Supprimer",
    notAnswered: "Sans réponse",
    notProvided: "Non renseigné",
    noEntries: "Aucune entrée.",
    noEntriesAdded: "Aucune entrée ajoutée.",
    noEntriesYet: "Aucune entrée pour l'instant.",
    noEntriesSubmitted: "Aucune entrée n'a été envoyée.",
    noDetails: "Aucun détail pour l'instant.",
    noDocChanges: "Aucune modification de document demandée.",
    noDocs: "Aucun document disponible.",
    leaveComment: "Laissez un commentaire...",
    addComment: "Ajouter un commentaire",
    addReply: "Répondre",
    cancel: "Annuler",
    youSent: "Vous avez envoyé",
    youAnswered: "Vous avez répondu :",
    addAnother: "En ajouter un autre ?",
    loadFailed: "Impossible de charger le questionnaire",
    oops: "Oups, un problème est survenu.",
    persists: "Si le problème persiste, contactez votre cabinet.",
    tryAgain: "Réessayer",
    attention_one: "Un fichier demande votre attention",
    attention_other: "{{count}} fichiers demandent votre attention",
    attentionBody:
      "Votre avocat pourra vous demander de les envoyer à nouveau.",
    sendAnyway: "Envoyer quand même",
    savesAuto: "Votre progression est enregistrée automatiquement",
    prefilledCount_one: "{{count}} réponse déjà remplie",
    prefilledCount_other: "{{count}} réponses déjà remplies",
    progressOf: "{{current}} sur {{total}}",
    savedAt: "Enregistré {{time}}",
    backToPortal: "Retour à votre portail",
    outline: {
      questions_one: "{{count}} question",
      questions_other: "{{count}} questions",
      filled_one: "{{count}} remplie",
      filled_other: "{{count}} remplies",
      minutes_one: "{{count}} min",
      minutes_other: "{{count}} min",
      done: "Terminé"
    },
    prefill: {
      ask: "Est-ce exact ?",
      yes: "Oui, c'est exact",
      change: "Modifier",
      fromDocs: "D'après vos documents",
      onFile: "Déjà dans votre dossier"
    },
    date: {
      day: "Jour",
      month: "Mois",
      year: "Année",
      pickMonth: "Choisissez un mois",
      echo: "Vous avez écrit : {{date}}",
      invalid: "Cette date n'existe pas. Vérifiez le jour et le mois."
    },
    ph: {
      email: "nom@exemple.com",
      phone: "+1 555 123 4567",
      givenName: "Comme sur votre passeport",
      familyName: "Comme sur votre passeport",
      middleName: "Laissez vide si vous n'en avez pas",
      otherNames: "Autres noms que vous avez utilisés",
      fullName: "Nom complet",
      number: "Tel qu'imprimé sur le document",
      city: "Ville",
      country: "Pays",
      employer: "Entreprise ou organisation",
      jobTitle: "Votre poste",
      school: "École ou université",
      website: "https://",
      longText: "Écrivez votre réponse ici…",
      answer: "Écrivez votre réponse ici…"
    },
    group: {
      tellUs: "Parlez-nous de : {{name}}.",
      tellUsAddresses: "Parlez-nous de vos adresses précédentes.",
      tellUsEmployment: "Parlez-nous de votre parcours professionnel.",
      tellUsStatuses:
        "Parlez-nous de votre historique de statuts d'immigration.",
      tellUsTrips: "Parlez-nous de vos entrées et sorties des États-Unis.",
      tellUsDependents: "Parlez-nous des personnes à votre charge.",
      leadIn: "Avez-vous quelque chose à ajouter : {{name}} ?",
      leadInAddresses: "Avez-vous des adresses précédentes à ajouter ?",
      leadInEmployment: "Avez-vous des emplois à ajouter ?",
      leadInStatuses: "Avez-vous des statuts d'immigration à ajouter ?",
      leadInTrips:
        "Avez-vous des entrées ou sorties des États-Unis à ajouter ?",
      addAnother: "Ajouter un autre élément : {{name}} ?",
      addAnotherAddress: "Ajouter une autre adresse ?",
      addAnotherEmployer: "Ajouter un autre employeur ?",
      addAnotherStatus: "Ajouter un autre statut ?",
      addAnotherTrip: "Ajouter un autre voyage ?",
      review: "Vérifiez : {{name}}",
      reviewAddresses: "Vérifiez vos adresses",
      reviewEmployers: "Vérifiez vos employeurs",
      reviewStatuses: "Vérifiez vos statuts",
      reviewTrips: "Vérifiez vos voyages",
      entries: "entrées"
    }
  },
  common: {
    loading: "Chargement…",
    today: "aujourd'hui",
    yesterday: "hier",
    daysAgo_one: "il y a 1 jour",
    daysAgo_other: "il y a {{count}} jours"
  }
};
